import { ref, computed } from 'vue'
import { useStore } from 'vuex'

import { getOkrListIdByCycle } from '@/api/okr'
import { getPublishedOkr } from '@/graphql/okr'

export default function useOkr () {
  const isLoading = ref(false)
  const store = useStore()
  const cycleId = computed(() => store.state.selectedCycleId)

  function getPublishedOkrByCycle (userId) {
    isLoading.value = true
    return getOkrListIdByCycle(cycleId.value, userId)
      .then(res => getPublishedOkr(res.id))
      .finally(() => {
        isLoading.value = false
      })
  }

  return {
    isLoading,
    getPublishedOkrByCycle
  }
}
